import React, {Component, Fragment} from 'react';
import Button, { ButtonGroup } from '@atlaskit/button';
import {FormFooter} from '@atlaskit/form';
import {Grid, GridColumn} from '@atlaskit/page';
import {ContentWrapper} from '../../components/ContentWrapper';
import styled from 'styled-components';
import {connect} from 'react-redux';
import DiagnosticActions from '../../redux/DiagnosticRedux';
import Forbidden from '../../components/Forbidden';
import dateformat from 'dateformat';
import DiagnosticListItem from './components/DiagnosticListItem';
import {withTranslation, Trans} from 'react-i18next';

const HeaderContainer = styled.div`
  display: flex;
  justify-content: space-between;
`;

const DateWrapper = styled.div`
  font-style: normal;
  font-weight: normal;
  font-size: 12px;
  line-height: 20px;
  color: #6B778C;
  padding-bottom: 16px;
`;

class DiagnosticPage extends Component {
  constructor(props) {
    super(props);

    this.state = {
    };
  }

  componentDidMount() {
    this.props.get();
  }

  onRefreshData = () => {
    this.props.get();
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.fetching !== this.props.fetching
      && prevProps.fetching
      && !this.props.error) {

    }
  }

  

  render() {
    const {
      permissions,
      fetching,
      dateResponse,
      data,
      t,
    } = this.props;

    if (!permissions.diagnostic) {
      return <Forbidden />;
    }

    return (
      <ContentWrapper>
        <HeaderContainer>
          <h1>{t('Diagnostics')}</h1>
          
          <Button
            appearance='danger'
            onClick={this.onRefreshData}
            isDisabled={fetching}
            isLoading={fetching}
          >
            <Trans>Refresh</Trans>
          </Button>
        </HeaderContainer>
        {dateResponse && (
          <Fragment>
            <DateWrapper>
            {t('Data renewed')} {dateformat(dateResponse, 'dd.mm.yyyy HH:MM')}
            </DateWrapper>
            {!data && (
              <p>
                <Trans>No Data</Trans>
              </p>
            )}
          </Fragment>
        )}

        {data && data.map(item => <DiagnosticListItem key={`diagnostic_itm_${item.name}`} {...item} />)}

      </ContentWrapper>
    );
  }
}
const mapStateToProps = state => {
  return {
    permissions: state.userProfile.permissions,
    data: state.diagnostic.data,
    dateResponse: state.diagnostic.dateResponse,
    fetching: state.diagnostic.fetching,
    error: state.diagnostic.error,
  };
};

const mapDispatchToProps = dispatch => {
  return {
    get: () => dispatch(DiagnosticActions.diagnosticRequest()),
  };
};

export default withTranslation('diagnostic', 'common')(connect(
  mapStateToProps,
  mapDispatchToProps,
)(DiagnosticPage));



const DATA = [
    {
      name: "JourneyApiKeepalive",
      description: "Keepalive JourneyApi",
      error: "Ошибка в контролере",
      time: "2020-06-08T21:45:58.769928Z",
      state: "ERROR"
    },
    {
      name: "ItelmaApiKeepalive",
      description: "Keepalive ItelmaApi",
      error: null,
      time: "2020-06-08T21:45:58.7699299Z",
      state: "SUCCESS"
    },
    {
      name: "JourneyAggregatorKeepalive",
      description: "Keepalive JourneyAggregator",
      error: null,
      time: "2020-06-08T21:45:58.7699307Z",
      state: "WARNING"
    },
    {
      name: "JourneyProcessorKeepalive",
      description: "Keepalive JourneyProcessor",
      error: null,
      time: "2020-06-08T21:45:58.7699311Z",
      state: "INFO"
    },
    {
      name: "ItelmaDB",
      description: "Проверка доступности базы данных Itelma",
      error: null,
      time: "2020-06-08T21:45:58.7702143Z",
      state: "SUCCESS"
    },
    {
      name: "JourneyAggregator",
      description: "Проверка работоспособности компонентов JourneyAggregator",
      error: null,
      time: "2020-06-08T21:45:58.7730511Z",
      state: "SUCCESS"
    },
    {
      name: "JasperCheck",
      description: "Проверка доступности Jasper",
      error: null,
      time: "2020-06-08T21:45:58.8143789Z",
      state: "SUCCESS"
    },
    {
      name: "Mqtt",
      description: "Проверка доступности Mqtt",
      error: null,
      time: "2020-06-08T21:46:01.8443664Z",
      state: "SUCCESS"
    }
];